import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  otp: '',
  data: {},
  otpCounter: 0,
};

const otpSlice = createSlice({
  name: 'otp',
  initialState,
  reducers: {
    updateData: (state, { payload }) => ({ ...state, data: payload }),
    updateOtp: (state, { payload }) => ({ ...state, otp: payload }),
    updateOTPCounter: (state, { payload }) => ({ ...state, otpCounter: payload }),
    incrementOTPCounter: (state) => ({
      ...state,
      otpCounter: state.otpCounter + 1,
      otp: initialState.otp,
    }),
    resetData: (state) => ({ ...state, data: initialState.data }),
    reset: () => initialState,
  },
});

export const {
  updateOTPCounter, incrementOTPCounter, updateData, updateOtp, reset: resetOTP, resetData,
} = otpSlice.actions;

export default otpSlice.reducer;
